import React, { useState } from "react";
import { Box, Table, TextField } from "@mui/material";
import { Button, Paper, Stack, TableBody, TableCell } from "@mui/material";
import { TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import DialogComponent from "../reusableComponents/Dialog";
import DateField from "../components/DateField";
import moment from "moment";
import { Toast } from "../components/Toast";
import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";

function EmployeeRoute() {
  const [state, setState] = useState({
    records: [],
    name: "",
    addModal: false,
    date: "",
    selectedDate: "",
    day: "",
    route: "",
  });

  const toggle = () => {
    setState((prev) => ({ ...prev, addModal: !prev.addModal }));
  };
  const handleDate = (e) => {
    const { name, value } = e.target;
    if (value) {
      let formatted = moment(value).format("DD-MM-YYYY");
      const dateParts = formatted.split("-");
      const dateObj = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      const day = dateObj.toLocaleString("en-us", { weekday: "long" });
      const monthName = dateObj.toLocaleString("en-us", { month: "long" });
      const d = moment(value).format("DD");
      let date = `${d} ${monthName}`;
      setState((prev) => ({ ...prev, [name]: value, day, selectedDate: date }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        day: "",
        selectedDate: "",
      }));
    }
  };
  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = () => {
    if (!state.date) {
      Toast("info", "Kindly Select Date");
      return;
    }
    if (!state.route) {
      Toast("info", "Kindly Add Location");
      return;
    }
    let record = {
      date: state.date,
      day: state.day,
      route: state.route,
      selectedDate: state.selectedDate,
    };
    setState((prev) => ({
      ...prev,
      records: [...prev.records, record],
      date: "",
      day: "",
      selectedDate: "",
      route: "",
      addModal: false,
    }));
  };
  const handlePrint = () => {
    if (!state.name) {
      Toast("info", "Add Name");
      return;
    }
    Print();
  };
  const Print = () => {
    let doc = new jsPDF();
    doc.setFontSize(10);
    let finalY = "";

    doc.setFontSize(18);
    doc.setFontStyle("bold");
    doc.text(localStorage.getItem("company"), 50, 22);
    doc.setFontStyle("normal");

    doc.setFontSize(12);
    doc.setFontStyle("normal");

    doc.text("Date :", 150, 53);
    doc.text(moment().format("DD-MM-YYYY"), 165, 53);

    doc.setFontSize(12);
    doc.text(localStorage.getItem("company") || "", 20, 58);
    let address = localStorage.getItem("address") || "";
    let phone =
      localStorage.getItem("phone") == null
        ? ""
        : localStorage.getItem("phone");
    let splitAddress = doc.splitTextToSize(address, 90);

    let position = 72;
    if (address.length >= 50 && address.length <= 100) {
      position = 75;
    } else if (address.length >= 100 && address.length <= 200) {
      position = 80;
    }

    doc.text(20, 65, splitAddress);
    doc.text(phone, 20, position);

    doc.text(20, position + 10, "Name :");
    doc.setFontStyle("bold");
    doc.setFontSize(14);
    doc.text(40, position + 10, state.name);
    doc.setFontStyle("normal");
    let img = new Image();

    let baseUrl = localStorage.getItem("base_url");

    if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
      let snapshot = employeeLogo;
      img.src = snapshot;
    } else {
      let snapshot = localStorage.getItem("base_url");
      img.src = snapshot;
    }

    doc.addImage(img, "png", 0, 0, 40, 40);
    jsPDF.autoTableSetDefaults({
      theme: "grid",
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        lineColor: [229, 229, 229],
        fontStyle: "bold",
        lineWidth: 0.5,
      },
      tableLineColor: [189, 195, 199],
      tableLineWidth: 0.75,
      margin: { left: 8, right: 8, bottom: 10 },
      bodyStyles: {
        color: "rgba(0, 0, 0, 0.87)",
        fontStyle: "bold",
      },
    });

    let col = [];

    col = ["#", "Date", "Day", "Route/Location"];

    let rows = [];
    state.records.forEach((item, index) => {
      doc.setFontSize(14);

      let temp = [index + 1, item.selectedDate, item.day, item.route];
      rows.push(temp);
    });
    doc.autoTable(col, rows, {
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 30 },
        2: { cellWidth: 30 },
        3: { cellWidth: 124 },
      },
      startY: 100,
    });

    finalY = doc.lastAutoTable.finalY;

    doc.setFontSize(10);

    doc.setFontSize(10);
    if (window.innerWidth <= 600) {
      doc.save("reciept");
    } else {
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    }
  };
  const handleClear = () => {
    setState((prev) => ({ ...prev, records: [] }));
  };
  return (
    <Box sx={{ pt: 3 }}>
      <Stack
        padding="10px 0px"
        direction="row"
        justifyContent="space-between"
        sx={{ mt: { md: "0px", xs: "40px" } }}
      >
        <Stack>
          <TextField
            size="small"
            name="name"
            label="Name"
            variant="outlined"
            value={state.name}
            onChange={handleInput}
          />
        </Stack>
        <Stack direction="row" spacing={2}>
          {state.records.length > 0 && (
            <Button size="small" variant="contained" onClick={handlePrint}>
              Print
            </Button>
          )}
          {state.records.length > 0 && (
            <Button size="small" variant="outlined" onClick={handleClear}>
              Clear
            </Button>
          )}
          <Button size="small" variant="contained" onClick={toggle}>
            Add
          </Button>
        </Stack>
      </Stack>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 550 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <TableCell width="15%">Date </TableCell>
              <TableCell width="15%">Day </TableCell>
              <TableCell>Route/Location </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state.records.map((item, index) => {
              return (
                <TableRow key={index}>
                  <TableCell component="th">{item.selectedDate} </TableCell>
                  <TableCell component="th">{item.day} </TableCell>
                  <TableCell component="th">{item.route} </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <DialogComponent
        title="Entry"
        open={state.addModal}
        onClose={toggle}
        dialogContent={
          <Stack spacing={2}>
            <Typography variant="h6" sx={{ color: "#4eaf51" }}>
              Add Route
            </Typography>
            <DateField value={state.date} onChange={handleDate} />

            <TextField
              fullWidth
              size="small"
              name="route"
              label="Route/Location"
              variant="outlined"
              value={state.route}
              onChange={handleInput}
            />
            <Stack direction="row" justifyContent="space-evenly">
              <Button
                size="small"
                variant="contained"
                onClick={toggle}
                sx={{
                  backgroundColor: "rgb(138, 138, 138) !important",
                }}
              >
                Cancel
              </Button>
              <Button size="small" variant="contained" onClick={handleSubmit}>
                Add Record
              </Button>
            </Stack>
          </Stack>
        }
      />
    </Box>
  );
}

export default EmployeeRoute;
